<template>
  <div class="stepper">
    <ProcessStep
      v-for="(step, i) in steps"
      :key="step.id"
      :step="step"
      :index="i + 1"
      :done="stepsDone.includes(step.id)"
      :substeps-done="substepsDone"
      :open="openIndex === i"
      :last="i === steps.length - 1"
      @toggle-open="openIndex = i"
      @toggle-done="$emit('step-toggle', step.id)"
      @substep-toggle="$emit('substep-toggle', $event)"
    />
  </div>
</template>

<script>
import ProcessStep from './ProcessStep.vue'

export default {
  name: 'ProcessStepper',
  components: {
    ProcessStep
  },
  props: {
    steps: {
      type: Array,
      required: true
    },
    stepsDone: {
      type: Array,
      required: true
    },
    substepsDone: {
      type: Array,
      required: true
    }
  },
  data () {
    const firstOpen = this.steps.findIndex((s) => !this.stepsDone.includes(s.id))
    return {
      openIndex: firstOpen === -1 ? 0 : firstOpen
    }
  }
}
</script>

<style scoped>
.stepper {
  display: flex;
  flex-direction: column;
}
</style>
